
import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  ref,
  watchEffect,
} from "vue";
import { appColors } from "@/config/globals";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import MainSpeaker from "../speakers/MainSpeaker.vue";

export default defineComponent({
  props: ["renderLimit"],
  setup(props) {
    const colors = computed(() => {
      const eventData = store.getters["user/eventData"];
      if (eventData.themeSettings) {
        if (eventData.themeSettings.cardColor1) {
          const cardColor1 = eventData.themeSettings.cardColor1;
          const cardColor2 = eventData.themeSettings.cardColor2;
          const cardColor3 = eventData.themeSettings.cardColor3;
          const cardColor4 = eventData.themeSettings.cardColor4;
          const eventColors: Array<string> = [];
          for (let index = 0; index < 4; index++) {
            eventColors.push(cardColor1);
            eventColors.push(cardColor2);
            eventColors.push(cardColor3);
            eventColors.push(cardColor4);
          }
          return eventColors;
        }
        return appColors;
      }
      return appColors;
    });
    const loading = ref(true);
    const router = useRouter();
    const store = useStore();
    store.dispatch("user/getFeaturesAccess", "speakers");
    const programsData: { [key: string]: any } = reactive({});
    const eventData = computed(() => {
      return store.getters["user/eventData"];
    });
    const getSpeakerAndPrograms = (data) =>
      store.dispatch("speakers/getSpeakerAndPrograms", data);

    onMounted(() => {
      if (eventData.value) {
        getSpeaker();
      }
    });
    const goToSpeakers = () => {
      router.push({
        name: "speakers",
        params: { eventID: eventData.value.id },
      });
    };

    const getSpeaker = async () => {
      loading.value = true;
      const speakerData = await getSpeakerAndPrograms({
        eventData: eventData.value.id,
        renderLimit: props.renderLimit,
      });
      for (var key in speakerData) delete programsData[key];
      for (const key in speakerData) {
        if (Object.prototype.hasOwnProperty.call(speakerData, key)) {
          programsData[key] = speakerData[key];
          if (programsData[key].dates) {
            programsData[key].dates = dateSorted(programsData[key].dates);
          }
        }
      }
      loading.value = false;
    };

    const dateSorted = (unordered) =>
      Object.keys(unordered)
        .sort()
        .reduce((obj, key) => {
          obj[key] = unordered[key];
          return obj;
        }, {});
    watchEffect(() => {
      if (eventData.value) {
        if (eventData.value.id)
          if (Object.keys(programsData).length === 0) getSpeaker();
      }
    });
    return {
      colors,
      programsData,
      eventData,
      loading,
      goToSpeakers,
    };
  },
  components: {
    AppMainSpeaker: MainSpeaker,
  },
});
